import React, { useEffect } from 'react';
import { compareDates } from '@utils/utils.astro';
import { Timer, MobileTransactionList } from '@components';
import { useTradeHistory } from '@hooks/useTrade';
import moment from 'moment-timezone';
import { millisecondsUntil } from '../../../utils/milliseconds-until';

const HistoryListHeaderShort = () => {
  return (
    <div className="history_list_header_short">
      <div className="item">
        <p className="history_list_header_long_item">Time left</p>
      </div>
      <div className="item">
        <p className="history_list_header_short_item">Token</p>
      </div>
      <div className="item">
        <p className="history_list_header_short_item">Max Trade Amount</p>
      </div>
      <div className="item">
        <p className="history_list_header_short_item">Result</p>
      </div>
    </div>
  );
};

const HistoryListHeaderLong = () => {
  return (
    <div className="w-full grid grid-cols-5 p-4 rounded-t-xl bg-[#212325] md:grid-cols-6">
      <div className="hidden md:flex justify-center items-center">
        <p className="history_list_header_long_item">Date</p>
      </div>
      <div className="item">
        <p className="history_list_header_long_item">Time left</p>
      </div>
      <div className="item">
        <p className="history_list_header_long_item">Token</p>
      </div>
      <div className="item">
        <p className="history_list_header_long_item">Type</p>
      </div>
      <div className="item">
        <p className="history_list_header_long_item">Max Trade Amount</p>
      </div>
      <div className="item">
        <p className="history_list_header_long_item">Result</p>
      </div>
    </div>
  );
};

const HistoryItemShort = ({ item }) => {
  return (
    <div className="history_item_short">
      <div
        className={`item counter counter_${
          !item.ended ? 'active' : 'inactive'
        }`}
      >
        {item.ended ? (
          <p className={`history_item_long_text ${!item.ended && 'black'}`}>
            CLOSED
          </p>
        ) : (
          <p className={`history_item_long_text ${!item.ended && 'black'}`}>
            <Timer endDate={item?.endDate} />
          </p>
        )}
      </div>
      <div className="item">
        <p className="history_item_short_text">{item?.coinId}</p>
      </div>
      <div className="item">
        <p className="history_item_short_text">${Math.abs(item?.amount)}</p>
      </div>
      <div className="item">
        {item?.ended ? (
          item?.status === 'profit' ? (
            <p className="green">Profit (+{item.profit}$)</p>
          ) : (
            <p className="red">Loss (-{Math.abs(item.amount)}$)</p>
          )
        ) : (
          <p className="text-yellow-400">Pending</p>
        )}
      </div>
    </div>
  );
};

const HistoryItemLong = ({ item, refresh }) => {
  return (
    <div className="grid grid-cols-5 w-full md:grid-cols-6">
      <div className="hidden md:flex justify-center items-center">
        <p className="history_item_long_text">
          {moment.utc(item?.startDate).local().format('YYYY-MM-DD')}
          <br />
          {moment.utc(item?.startDate).local().format('HH:mm:ss')}
        </p>
      </div>
      <div
        className={`item counter counter_${
          !item.ended ? 'active' : 'inactive'
        }`}
      >
        {item.ended ? (
          <p className={`history_item_long_text ${!item.ended && 'black'}`}>
            CLOSED
          </p>
        ) : (
          <p className={`history_item_long_text ${!item.ended && 'black'}`}>
            <Timer endDate={item?.endDate} />
          </p>
        )}
      </div>
      <div className="item">
        <p className="history_item_long_text">{item?.coinId}</p>
      </div>
      <div className="item">
        <p className="history_item_long_text">{item?.type}</p>
      </div>
      <div className="item">
        <p className="history_item_long_text">${item?.amount}</p>
      </div>
      <div className="item">
        {item?.ended ? (
          item?.status === 'profit' ? (
            <p className="green">Profit (+{item.profit}$)</p>
          ) : (
            <p className="red">Loss (-{Math.abs(item.amount)}$)</p>
          )
        ) : (
          <p className="text-yellow-400">Pending</p>
        )}
      </div>
    </div>
  );
};

const HistoryItemWrapper = ({ item, children }) => {
  const { getAwaitedTrade } = useTradeHistory();
  const [isUsed, setIsUsed] = React.useState(false);

  useEffect(() => {
    if (!item.ended && !isUsed) {
      setIsUsed(true);

      const timeout = Math.max(0, millisecondsUntil(item.endDate + 3000));

      setTimeout(() => {
        getAwaitedTrade(item._id);
      }, timeout);
    }
  }, [item, isUsed]);

  return children;
};

const LongList = ({ history, refresh }) => {
  return (
    <div className="list_body">
      <HistoryListHeaderLong />
      <div className="body">
        {history?.map((item, index) => (
          <HistoryItemWrapper item={item} key={item._id}>
            <HistoryItemLong item={item} refresh={refresh} />
          </HistoryItemWrapper>
        ))}
      </div>
    </div>
  );
};

const ShortList = ({ history }) => {
  return (
    <div className="list_body">
      <HistoryListHeaderShort />
      <div className="body">
        {history?.map((item, index) => (
          <HistoryItemWrapper item={item} key={item._id}>
            <HistoryItemShort item={item} />
          </HistoryItemWrapper>
        ))}
      </div>
    </div>
  );
};

const TransactiosHistory = ({ history, size, refresh }) => {
  return (
    <div className="container history_container max-w-full">
      <>
        <div className="header">
          <h1 className="title">Your Operations</h1>
        </div>
        <div
          className="history_list"
          style={{
            height: '100%',
            width: '100%',
            display: 'flex',
            flex: 1,
            justifyContent:
              history && history.length > 0 ? 'flex-start' : 'center',
            justifyContent:
              history && history.length > 0 ? 'flex-start' : 'center',
          }}
        >
          {history && history.length > 0 ? (
            size === 'short' ? (
              <ShortList history={history} refresh={refresh} />
            ) : (
              <LongList history={history} refresh={refresh} />
            )
          ) : (
            <div className="empty_state">
              <h1 className="no_history_indicator">
                It seems you don't have any operations yet
              </h1>
            </div>
          )}
        </div>
      </>
    </div>
  );
};

export default TransactiosHistory;
